import clsx from 'clsx';
import styles from './Pagination.module.css';
import { ChevronLeftIcon, ChevronRightIcon } from '../icons';
import { buildPageItems } from './lib/buildPageItems';

export function Pagination({ page, totalPages, onPageChange, ariaLabel = 'Pagination' }) {
  const currentPage = Math.max(1, Number(page) || 1);
  const pagesTotal = Math.max(1, Number(totalPages) || 1);

  const items = buildPageItems(currentPage, pagesTotal);

  const canGoPrev = currentPage > 1;
  const canGoNext = currentPage < pagesTotal;

  return (
    <nav className={clsx(styles.pagination)} aria-label={ariaLabel}>
      <button
        type="button"
        className={clsx(styles.arrow)}
        aria-label="Previous page"
        disabled={!canGoPrev}
        onClick={() => onPageChange?.(currentPage - 1)}
      >
        <ChevronLeftIcon aria-hidden />
      </button>

      {items.map((item, index) =>
        item === 'ellipsis' ? (
          <div
            key={`ellipsis-${index}`}
            className={clsx(styles.page, styles.ellipsis)}
            aria-hidden="true"
          >
            ...
          </div>
        ) : (
          <button
            key={`page-${item}`}
            type="button"
            className={clsx(styles.page, item === currentPage && styles.selected)}
            aria-current={item === currentPage ? 'page' : undefined}
            aria-label={`Page ${item}`}
            onClick={() => onPageChange?.(item)}
          >
            {item}
          </button>
        ),
      )}

      <button
        type="button"
        className={clsx(styles.arrow)}
        aria-label="Next page"
        disabled={!canGoNext}
        onClick={() => onPageChange?.(currentPage + 1)}
      >
        <ChevronRightIcon aria-hidden />
      </button>
    </nav>
  );
}
